module.exports = __webpack_public_path__ + "static/hugo-73bce823b83a8157f340e2c008c84744.jpg";